import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

import { breakpoints } from '../../constants';
import calendImage from './calend.svg';
import placeMarkerImage from './placeMarker.svg';
import covid19Image from './covid19.svg';

const Wrapper = styled.div`
    padding: 0 1rem;
    display: flex;
    align-items: center;
    p {
        font-size: 70%;
        line-height: 120%;
        font-weight: bold;
        text-align: left;
    }
    @media (max-width: ${breakpoints.tablet}) {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
    }
    @media (max-width: ${breakpoints.mobile}) {
        width: 100%;
        flex-direction: column;
        p {
            font-size: 100%;
            line-height: initial;
        }
    }
`;

const Item = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    img {
        height: 50px;
        margin-right: 0.5rem;
    }
`;

const ScheduleDatesItems = styled.div`
    position: relative;
    width: 70%;
    margin-left: 0.5rem;
    &:before {
        content: '';
        border-left: 1px dotted #087ea8;
        display: block;
        width: 1px;
        height: 100%;
        left: 10px;
        position: absolute;
        z-index: -1;
    }
    @media (max-width: ${breakpoints.tablet}) {
        margin-left: 7.5rem;
    }
    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 1.7rem;
        margin-top: 1rem;
        width: 100%;
    }
`;

const ScheduleDatesItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    &:last-of-type {
        margin-bottom: 0;
    }
    span {
        display: inline-block;
        margin-right: 1.4rem;
        font-size: 60%;
        text-align: center;
        width: 20px;
        height: 20px;
        line-height: 2;
        color: white;
        border-radius: 80px;
        border: 1px solid #087ea8;
        background-color: #087ea8;
    }
`;
const ScheduleDate = styled.div`
    p:nth-of-type(2) {
        color: #22c3f1;
    }
`;

const Component = ({ style, className, intl }) => (
    <Wrapper style={style} className={className}>
        <div>
            <Item>
                <img src={calendImage} />
                <div>
                    <p>10•11</p>
                    <p>
                        <FormattedMessage id="scheduleWidget.dates" />
                    </p>
                </div>
            </Item>
            <Item>
                <img src={placeMarkerImage} />
                <div>
                    <p>
                        <a
                            href="https://yandex.ru/maps/-/CHRhIG-I"
                            target="__blank"
                        >
                            <FormattedMessage id="scheduleWidget.address" />
                        </a>
                    </p>
                </div>
            </Item>
        </div>

        <ScheduleDatesItems>
            <ScheduleDatesItem>
                <span>10</span>
                <ScheduleDate>
                    <FormattedMessage id="scheduleWidget.date1" tagName="p" />
                    <p>10:00 - 18:00</p>
                </ScheduleDate>
            </ScheduleDatesItem>
            <ScheduleDatesItem>
                <span>11</span>
                <ScheduleDate>
                    <FormattedMessage id="scheduleWidget.date2" tagName="p" />
                    <p>10:00 -17:00</p>
                </ScheduleDate>
            </ScheduleDatesItem>
        </ScheduleDatesItems>
    </Wrapper>
);

export default injectIntl(Component);



// WEBPACK FOOTER //
// ./src/components/ScheduleWidget/index.js